(function () {
    'use strict';

    angular
        .module('questionnaireTemplatesEditModule', [
            'oddQuestionnaireTemplateModule',
            'oddPublicModule',
            'services.historyCtxt',
            'services.notification'
        ]);
})();
